module.exports = __webpack_public_path__ + "img/bindChat_b.048c5431.png";